
namespace TabAurous.OMS {

    @Serenity.Decorators.registerClass()
    export class AdditionalChargesGrid extends Serenity.EntityGrid<AdditionalChargesRow, any> {
        protected getColumnsKey() { return 'OMS.AdditionalCharges'; }
        protected getDialogType() { return AdditionalChargesDialog; }
        protected getIdProperty() { return AdditionalChargesRow.idProperty; }
        protected getInsertPermission() { return AdditionalChargesRow.insertPermission; }
        protected getLocalTextPrefix() { return AdditionalChargesRow.localTextPrefix; }
        protected getService() { return AdditionalChargesService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}